<article
  class="information-card bg-white d-flex flex-column w-100 h-100 overflow-hidden"
>
  @if (showImage() && image(); as cardImage) {
    <figure class="information-card__image-container w-100 overflow-hidden m-0">
      <picture>
        <img *scImage="cardImage" class="w-100 h-100 object-fit-cover" />
      </picture>
    </figure>
  }

  <div
    class="information-card__content d-flex flex-column flex-grow-1 text-break"
  >
    <h3 *scText="title()" class="mt-3"></h3>
    @if (showContent() && content(); as content) {
      <wl-rich-text-wrapper class="flex-grow-1" [field]="content"
        ><div class="mb-3"></div
      ></wl-rich-text-wrapper>
    }

    @if (button(); as button) {
      <crnt-button-alt
        variant="secondary"
        [fullWidth]="true"
        wlTrackLink
        [trackLinkInfo]="{
          rendering: { componentName: 'InformationCardComponent' },
          field: button.value?.text || '',
          eventType: 'button-click',
          type: 'button',
        }"
      >
        <a *wlGenericLink="button">
          {{ button.value?.text }}
          @if (button.value?.srSuffix; as srSuffix) {
            <span class="sr-only">{{ srSuffix }}</span>
          }
        </a>
      </crnt-button-alt>
    }
  </div>
</article>
